import forum_conf from '../assets/configs/forum/conf.json'
import Vue from "vue";

Vue.prototype.$forum_conf = forum_conf

